import { combineReducers } from 'redux';

import user from './reducers/user.reducers';
import toast from './reducers/toast.reducers';
import recipient from './reducers/recipient.reducers';
import general from './reducers/general.reducers';
import progress from './reducers/progress.reducers';
import receipt from './reducers/receipt.reducers';
import thankYouNote from './reducers/thankYouNote.reducers';
import reportCard from './reducers/reportCard.reducers';
import photo from './reducers/photo.reducers';
import recipientApp from './reducers/recipientApp.reducers';
import recipientMiscDoc from './reducers/recipientMiscDoc.reducers';
import reconciliation from './reducers/reconciliation.reducers';
import donor from './reducers/donor.reducers';
import donation from './reducers/donation.reducers';
import donorRecipient from './reducers/donorRecipient.reducers';

export default combineReducers({
    user,
    toast,
    recipient,
    general,
    progress,
    receipt,
    thankYouNote,
    reportCard,
    photo,
    recipientApp,
    recipientMiscDoc,
    reconciliation,
    donor,
    donation,
    donorRecipient,
});



// WEBPACK FOOTER //
// ./src/redux/rootReducers.js